import type { Drama } from './dramas';

export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  { slug: 'guochanju', name: '国产剧', description: '最新国产电视剧，经典国剧在线观看', icon: 'ri-shield-star-line' },
  { slug: 'gangju', name: '港剧', description: 'TVB经典港剧，最新港剧在线看', icon: 'ri-building-2-line' },
  { slug: 'meiju', name: '美剧', description: '热门美剧高清在线，美剧迷必看', icon: 'ri-global-line' },
  { slug: 'hanju', name: '韩剧', description: '最新韩剧推荐，浪漫韩剧大合集', icon: 'ri-heart-pulse-line' },
  { slug: 'riju', name: '日剧', description: '经典日剧、最新日剧在线播放', icon: 'ri-sun-line' },
  { slug: 'taiju', name: '台剧', description: '热门台剧推荐，偶像剧经典合集', icon: 'ri-star-smile-line' },
  { slug: 'oumeiju', name: '欧美剧', description: '欧美热门电视剧全集在线观看', icon: 'ri-earth-line' },
  { slug: 'donghuaju', name: '动画剧', description: '最新动漫番剧，经典动画在线看', icon: 'ri-movie-2-line' },
];